import React from 'react';
import './ContentPlugins.css';

export default function PluginSlotBadge({ pluginId }) {
  if (!pluginId) return null;
  const label = pluginId === 'weather' ? 'Weather'
    : pluginId === 'sports' ? 'Sports'
      : pluginId === 'social' ? 'Social'
        : pluginId === 'trivia' ? 'Trivia' : 'Plugin';
  const icon = pluginId === 'weather' ? '🌤️'
    : pluginId === 'sports' ? '🏆'
      : pluginId === 'social' ? '📱'
        : pluginId === 'trivia' ? '🎯' : '🧩';
  return (
    <span className="pluginSlotBadge">
      {icon} {label}
    </span>
  );
}
